import React from "react";
import Agent from "./agent.jsx";
export const comfirmBooking = async (appointmentData) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.post(`/booking/appointment`, appointmentData, token);
};
export const getAppointment = async (bookingId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(`/booking/appointment/${bookingId}`, token);
};
export const getAppointments = async (date) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const localDate = new Date();
  const dateOnly =
    localDate.getFullYear() +
    "-" +
    String(localDate.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(localDate.getDate()).padStart(2, "0");
  const params = {
    ShopId: "EBC2A5EA-E6FA-45A4-CFFB-08DDD4FB6DDE",
    Date: dateOnly,
  };
  return await requests.getAtt(`/booking/appointmentsperDate`, params, token);
};
export const getappointmentsByFillter = async (params) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.getAtt(`/booking/filterAppointments`, params, token);
};
